import { _ as _instanceof } from "@swc/helpers/_/_instanceof";
import React from "react";
import { isNewWebImplementationEnabled } from "./EnableNewWebImplementation";
//GestureHandlers
import InteractionManager from "./web/tools/InteractionManager";
import NodeManager from "./web/tools/NodeManager";
import PanGestureHandler from "./web/handlers/PanGestureHandler";
import TapGestureHandler from "./web/handlers/TapGestureHandler";
import LongPressGestureHandler from "./web/handlers/LongPressGestureHandler";
import PinchGestureHandler from "./web/handlers/PinchGestureHandler";
import RotationGestureHandler from "./web/handlers/RotationGestureHandler";
import FlingGestureHandler from "./web/handlers/FlingGestureHandler";
import NativeViewGestureHandler from "./web/handlers/NativeViewGestureHandler";
import ManualGestureHandler from "./web/handlers/ManualGestureHandler";
import HoverGestureHandler from "./web/handlers/HoverGestureHandler";
//Hammer Handlers
import * as HammerNodeManager from "./web_hammer/NodeManager";
import HammerNativeViewGestureHandler from "./web_hammer/NativeViewGestureHandler";
import HammerPanGestureHandler from "./web_hammer/PanGestureHandler";
import HammerTapGestureHandler from "./web_hammer/TapGestureHandler";
import HammerLongPressGestureHandler from "./web_hammer/LongPressGestureHandler";
import HammerPinchGestureHandler from "./web_hammer/PinchGestureHandler";
import HammerRotationGestureHandler from "./web_hammer/RotationGestureHandler";
import HammerFlingGestureHandler from "./web_hammer/FlingGestureHandler";
import { GestureHandlerWebDelegate } from "./web/tools/GestureHandlerWebDelegate";
export var Gestures = {
    NativeViewGestureHandler: NativeViewGestureHandler,
    PanGestureHandler: PanGestureHandler,
    TapGestureHandler: TapGestureHandler,
    LongPressGestureHandler: LongPressGestureHandler,
    PinchGestureHandler: PinchGestureHandler,
    RotationGestureHandler: RotationGestureHandler,
    FlingGestureHandler: FlingGestureHandler,
    ManualGestureHandler: ManualGestureHandler,
    HoverGestureHandler: HoverGestureHandler
};
export var HammerGestures = {
    NativeViewGestureHandler: HammerNativeViewGestureHandler,
    PanGestureHandler: HammerPanGestureHandler,
    TapGestureHandler: HammerTapGestureHandler,
    LongPressGestureHandler: HammerLongPressGestureHandler,
    PinchGestureHandler: HammerPinchGestureHandler,
    RotationGestureHandler: HammerRotationGestureHandler,
    FlingGestureHandler: HammerFlingGestureHandler
};
export default {
    handleSetJSResponder: function handleSetJSResponder(tag, blockNativeResponder) {
        console.warn("handleSetJSResponder: ", tag, blockNativeResponder);
    },
    handleClearJSResponder: function handleClearJSResponder() {
        console.warn("handleClearJSResponder: ");
    },
    createGestureHandler: function createGestureHandler(handlerName, handlerTag, config) {
        if (isNewWebImplementationEnabled()) {
            if (!(handlerName in Gestures)) {
                throw new Error("react-native-gesture-handler: ".concat(handlerName, " is not supported on web."));
            }
            var GestureClass = Gestures[handlerName];
            NodeManager.createGestureHandler(handlerTag, new GestureClass(new GestureHandlerWebDelegate()));
            InteractionManager.getInstance().configureInteractions(NodeManager.getHandler(handlerTag), config);
        } else {
            if (!(handlerName in HammerGestures)) {
                throw new Error("react-native-gesture-handler: ".concat(handlerName, " is not supported on web."));
            }
            // @ts-ignore If it doesn't exist, the error is thrown
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            var GestureClass1 = HammerGestures[handlerName];
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            HammerNodeManager.createGestureHandler(handlerTag, new GestureClass1());
        }
        this.updateGestureHandler(handlerTag, config);
    },
    attachGestureHandler: function attachGestureHandler(handlerTag, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    newView, _actionType, propsRef) {
        if (!(_instanceof(newView, HTMLElement) || _instanceof(newView, React.Component))) {
            return;
        }
        if (isNewWebImplementationEnabled()) {
            //@ts-ignore Types should be HTMLElement or React.Component
            NodeManager.getHandler(handlerTag).init(newView, propsRef);
        } else {
            //@ts-ignore Types should be HTMLElement or React.Component
            HammerNodeManager.getHandler(handlerTag).setView(newView, propsRef);
        }
    },
    updateGestureHandler: function updateGestureHandler(handlerTag, newConfig) {
        if (isNewWebImplementationEnabled()) {
            NodeManager.getHandler(handlerTag).updateGestureConfig(newConfig);
            InteractionManager.getInstance().configureInteractions(NodeManager.getHandler(handlerTag), newConfig);
        } else {
            HammerNodeManager.getHandler(handlerTag).updateGestureConfig(newConfig);
        }
    },
    getGestureHandlerNode: function getGestureHandlerNode(handlerTag) {
        if (isNewWebImplementationEnabled()) {
            return NodeManager.getHandler(handlerTag);
        } else {
            return HammerNodeManager.getHandler(handlerTag);
        }
    },
    dropGestureHandler: function dropGestureHandler(handlerTag) {
        if (isNewWebImplementationEnabled()) {
            NodeManager.dropGestureHandler(handlerTag);
        } else {
            HammerNodeManager.dropGestureHandler(handlerTag);
        }
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    flushOperations: function flushOperations() {}
};
